import { Box, Icon } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { CaptionText } from "~/components/Typographies";
import localizedText from "~/helpers/localizedText";

export interface DashboardScope {
	label: string;
	labelKey?: string;
	scopedToSite: boolean;
}

interface DashboardScopeChipProps {
	scope: DashboardScope;
}

const DashboardScopeChip = ({ scope }: DashboardScopeChipProps) => {
	const { t } = useTranslation("common");
	const label = localizedText(scope.label, scope.labelKey, t);

	return (
		<Box
			sx={{
				alignItems: "center",
				backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.06),
				borderRadius: 1,
				display: "inline-flex",
				gap: 0.5,
				minWidth: 0,
				overflow: "hidden",
				px: 0.75,
				py: 0.25
			}}
			title={label}
		>
			<Icon sx={{ color: "text.secondary", flexShrink: 0, fontSize: "0.8rem" }}>
				{scope.scopedToSite ? "place" : "public"}
			</Icon>
			<CaptionText
				sx={{
					color: "text.secondary",
					fontWeight: 600,
					lineHeight: 1,
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap"
				}}
			>
				{label}
			</CaptionText>
		</Box>
	);
};

export default DashboardScopeChip;
